import { render, staticRenderFns } from "./TransactionParticipantModal.vue?vue&type=template&id=48a5d079"
import script from "./TransactionParticipantModal.vue?vue&type=script&lang=ts"
export * from "./TransactionParticipantModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports